let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lwxLZ")).then(() => parcelRequire('f58lN'));